import React from 'react';
import NavLst from './Nav';
import Wrapper from './Wrapper'

export default function App(props) {

    const testuser01 = {name: "testuser01"}

    const [expandPlan, setExpand] = React.useState(false);
    const [currUser, setUser] = React.useState(testuser01);

    return (
        <div className="body">
            <NavLst setExpand={setExpand} currUser={currUser}/>

            <Wrapper expandPlan={expandPlan} setExpand={setExpand} currUser={currUser} setUser={setUser}/>
        </div>
    );

}